module.exports = __webpack_public_path__ + "img/number_bg_03.71d5feb9.png";